module.exports = __webpack_public_path__ + "static/media/listImoveisDescontoMobile.997b9052.png";